import { useLocale, useTranslations } from 'next-intl';
import type { ComponentPropsWithoutRef, MouseEventHandler } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

import { EventType } from '@/analytics/types';
import LandingPageCards from '@/app/components/LandingPage/LandingPageCards';
import getLocalePartialUrl from '@/utils/getLocalePartialUrl';

const IntegrationsAppCards = () => {
  const t = useTranslations();
  const locale = useLocale();
  const localePartialUrl = getLocalePartialUrl(locale);

  const handleCardLinkClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    const { href } = event.currentTarget;
    void window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'read more',
      location: 'body',
      path: href,
    });
  };
  const baseCardCtaData: {
    label: MessageKey;
    onClick: MouseEventHandler<HTMLAnchorElement>;
    target: ComponentPropsWithoutRef<'a'>['target'];
  } = {
    label: 'integrations_card_read_more',
    onClick: handleCardLinkClick,
    target: '_blank',
  };

  return (
    <div className="py-20">
      <LandingPageCards
        cards={[
          {
            description: {
              messageKey: 'integrations_headspace_description',
            },
            id: 'headspace',
            image: {
              localizedAlt: 'integrations_headspace_card_img_alt',
              src: '/blue-sky/integrations/headspace-card.png',
            },
            link: {
              ...baseCardCtaData,
              href: `https://ouraring.com/blog${localePartialUrl}oura-headspace-partnership/`,
              values: {
                appName: t('integrations_app_name_headspace'),
              },
            },
            title: {
              messageKey: 'integrations_app_name_headspace',
            },
          },
          {
            description: {
              messageKey: 'integrations_strava_description',
            },
            id: 'strava',
            image: {
              localizedAlt: 'integrations_strava_card_img_alt',
              src: '/blue-sky/integrations/strava-card.png',
            },
            link: {
              ...baseCardCtaData,
              href: `https://ouraring.com/blog${localePartialUrl}oura-and-strava-partnership/`,
              values: {
                appName: t('integrations_app_name_strava'),
              },
            },
            title: {
              messageKey: 'integrations_app_name_strava',
            },
          },
          {
            description: {
              messageKey: 'integrations_natural_cycles_description',
            },
            id: 'natural_cycles',
            image: {
              localizedAlt: 'integrations_natural_cycles_card_img_alt',
              src: '/blue-sky/integrations/natural-cycles-card.png',
            },
            link: {
              ...baseCardCtaData,
              href: `https://ouraring.com/blog${localePartialUrl}oura-partners-with-fda-cleared-birth-control-app-natural-cycles/`,
              values: {
                appName: t('integrations_app_name_natural_cycles'),
              },
            },
            title: {
              messageKey: 'integrations_app_name_natural_cycles',
            },
          },
        ]}
      />
    </div>
  );
};

export default IntegrationsAppCards;
